import type { Requests } from "../common/request.common";
import type { AssociateWagentResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const associateWagent = {
    login() {
        return postEmpty<AssociateWagentResponseTypes.Login>(`/associate-wagent/login`);
    },
    logout() {
        return postEmpty(`/associate-wagent/logout`);
    },
    obtain() {
        return get<AssociateWagentResponseTypes.Obtain>(`/associate-wagent/obtain`);
    },
    sendMessage(data: typeof Requests.AssociateWagent.SendMessage.Input) {
        return post<typeof data>(`/associate-wagent/send-message`, data);
    },
    broadcastMessage(data: typeof Requests.AssociateWagent.BroadcastMessage.Input) {
        return post<typeof data>(`/associate-wagent/broadcast-message`, data);
    },
    deleteBroadcast(id: string) {
        return postEmpty(`/associate-wagent/delete-broadcast/${id}`);
    },
};
